import useIsSubscribed from 'hooks/useIsSubscribed';
import { useLeadsContext } from 'pages/Leads/context';
import { useMemo } from 'react';
import { checkCompanySetupInProgress } from './helpers';

export interface LeadsBannerHook {
  showBanner: boolean;
  isLoading: boolean;
  showOptions: boolean;
  setupInProgress: boolean;
  hasActiveFilters: boolean;
  showSubscriptionBanner: boolean;
  archive: boolean;
  showSearch: boolean;
}

export default function useLeadsBanner(): LeadsBannerHook {
  const {
    leads,
    isLoading,
    noLeads,
    company,
    hasActiveFilters,
    archive,
    showOptions,
  } = useLeadsContext();

  const setupInProgress = useMemo(
    () => checkCompanySetupInProgress(company),
    [company],
  );

  const { isSubscribed } = useIsSubscribed();

  const showSubscriptionBanner = useMemo(
    () => !isLoading && !setupInProgress && !archive && !isSubscribed,
    [isLoading, setupInProgress, archive, isSubscribed],
  );

  const showSearch = useMemo(() => {
    if (isLoading) return true;
    return !noLeads;
  }, [isLoading, noLeads]);

  const showBanner = useMemo(() => {
    if (isLoading) return true;
    if (noLeads) return false;
    if (leads.length === 0 && !noLeads) return true;
    return true;
  }, [isLoading, noLeads, leads]);

  return {
    showBanner,
    isLoading,
    showOptions,
    setupInProgress,
    hasActiveFilters,
    showSubscriptionBanner,
    archive,
    showSearch,
  };
}
